import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Form label. A plain styled <label> (no extra Radix dep — only react-slot is
 * vendored). Pair with a control via `htmlFor`/`id` so the field is labelled
 * (ENGINEERING.md §8). The peer-disabled styles dim the label with its control.
 */
const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  // Base primitive — callers associate it with a control via `htmlFor`/`id` or
  // by nesting the control; association can't be asserted at the primitive.
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label
    ref={ref}
    className={cn(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className,
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
